import { render, staticRenderFns } from "./TemplateSelectionStage.vue?vue&type=template&id=20d0d222&scoped=true"
import script from "./TemplateSelectionStage.vue?vue&type=script&lang=js"
export * from "./TemplateSelectionStage.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelectionStage.vue?vue&type=style&index=0&id=20d0d222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0d222",
  null
  
)

export default component.exports